<div
  class="popup marginBottomStyle"
  style="position: relative; height: 100%; overflow: hidden"
>
  <div class="row topRowMargins headerStyle" style="margin-top: 0">
    <div style="margin-left: 15px">
      <label class="textColour">{{titleText}}</label>
    </div>
  </div>

  <div class="container" style="margin: 0; padding: 0">
    <form [formGroup]="SignalSourcesForm" novalidate>
      <div class="row">
        <!-- Source Type -->
        <div class="col-lg-6">
          <mat-form-field class="filter" appearance="outline">
            <mat-label>Source Type</mat-label>

            <mat-select formControlName="sourceType">
              <mat-option value="Internal">Internal</mat-option>
              <mat-option value="External">External</mat-option>
            </mat-select>

            <mat-error
              *ngIf="
                SignalSourcesForm.get('sourceType')?.touched &&
                SignalSourcesForm.get('sourceType')?.invalid
              "
            >
              Source Type is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Source Name -->
        <div class="col-lg-6">
          <mat-form-field class="filter" appearance="outline">
            <mat-label>Source Name</mat-label>

            <input
              matInput
              type="text"
              placeholder="Source Name"
              formControlName="sourceName"
              maxlength="100"
            />

            <mat-error
              *ngIf="SignalSourcesForm.get('sourceName')?.invalid"
            >
              Source Name is required
            </mat-error>
                  <mat-error *ngIf="SignalSourcesForm.get('sourceName')?.hasError('specialCharacter')">
                    Special characters are not allowed
                    </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer Buttons -->
  <div
    class="row mb-1 topRowMargins"
    style="position: absolute; width: 100%; bottom: 0"
  >
    <div class="col-lg text-center">
      <div style="text-align: end">
        <app-common-button
          *ngIf="!isEditMode"
          label="Save"
          title="Save"
          [buttonId]="1111"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onCreate()"
          style="margin-right: 1%"
        >
        </app-common-button>

        <app-common-button
          *ngIf="isEditMode"
          label="Update"
          title="Update"
          [buttonId]="1111"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onUpdate()"
          style="margin-right: 1%"
        >
        </app-common-button>

        <app-common-button
          label="Cancel"
          title="Cancel"
          [buttonId]="1111"
          [variant]="'cancel'"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onCancel()"
        >
        </app-common-button>
      </div>
    </div>
  </div>
</div>
